import { FC, useMemo } from 'react';

import Link from 'next/link';

import { routes } from '~/shared/constants/routes';

import { usePasswordRecovery } from '~/modules/auth/hooks/usePasswordRecovery';

import { AuthTitle } from '~/shared/components/AuthLayout/AuthTitle';
import { AuthForm } from '~/shared/components/AuthLayout/AuthForm';
import { PasswordRecoverySteps } from '~/modules/auth/components/PasswordRecoverySteps';

import { FormFooter } from './styles';

export const PasswordRecovery: FC = () => {
  const { currentStep } = usePasswordRecovery();

  const authTitle = useMemo(() => {
    return {
      1: 'Qual a forma de recuperação?',
      2: 'Recupere sua senha',
      3: 'Qual o código de recuperação?',
      4: 'Escolha uma nova senha',
    }[currentStep];
  }, [currentStep]);

  return (
    <>
      <AuthTitle title={authTitle} />

      <AuthForm as="aside">
        <PasswordRecoverySteps />

        <FormFooter>
          <span>
            Não precisa recuperar a senha?{' '}
            <Link href={routes.AUTH.SIGN_IN}>Entrar</Link>
          </span>
        </FormFooter>
      </AuthForm>
    </>
  );
};
